import React, { useEffect, useRef, useState } from "react";
import "./CollectionsPage.scss";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import CollectionsList from "../../Components/CollectionsList/CollectionsList";
import "../../styles/Title.scss";
import { Course } from "../../Models/Course";
import { useAppContext } from "../../Context/AppContext";
import { useAppSelector } from "../../store/hooks";
import {
  selectCourseError,
  selectCourses,
  selectCoursesLoading,
} from "../../store/collections";

const CollectionsPage = () => {
  const courses = useAppSelector(selectCourses);
  const loadingCourses = useAppSelector(selectCoursesLoading);
  const courseListError = useAppSelector(selectCourseError);

  const { setShowLoader, searchBarOpen } = useAppContext();
  const [filteredCollections, setFilteredCollections] = useState<Course[]>([]);

  useEffect(() => {
    if (!loadingCourses) {
      setFilteredCollections(courses);
      setShowLoader(false);
    } else {
      setShowLoader(true);
    }
  }, [loadingCourses]);

  // function that handles setting the current value when the search button is clicked.
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value;
    if (!query) {
      setFilteredCollections([...courses]);
      return;
    }

    const tempList = [...courses];
    const searchedCollections = tempList.filter((collection: any) =>
      collection.name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredCollections(searchedCollections);
  };

  return (
    <>
      <MobileHeader
        searchBar={true}
        onSearch={handleSearch}
        searchBarText={"Search courses"}
      />

      <div className={`page ${searchBarOpen ? "search-bar-open" : ""}`}>
        {courses === null ? (
          <p>No courses</p>
        ) : (
          <CollectionsList collections={filteredCollections} />
        )}
      </div>
    </>
  );
};

export default CollectionsPage;
